<template>
  <div class="processing-comments">
    <p v-if="row.observations">
      <strong>Observaciones:</strong> {{ row.observations }}
    </p>
    <article v-for="(entry, index) in entries" :key="index">
      <small
        >{{ entry.author || 'Vanguard'
        }}<template v-if="entry.createdAt">
          · {{ formatDate(entry.createdAt) }}</template
        ></small
      >
      <p>{{ entry.text }}</p>
    </article>
    <span v-if="!entries.length && !row.observations">—</span>
  </div>
</template>
<script>
import moment from 'moment-timezone'
export default {
  props: { row: { type: Object, required: true } },
  computed: {
    entries() {
      return this.row.processComments && this.row.processComments.length
        ? this.row.processComments
        : this.row.processComment
        ? [{ text: this.row.processComment, author: 'Comentario anterior' }]
        : []
    },
  },
  methods: {
    formatDate(value) {
      return moment(value)
        .tz('America/Panama')
        .format('DD/MM/YYYY HH:mm')
    },
  },
}
</script>
<style scoped>
.processing-comments {
  min-width: 180px;
  max-width: 360px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
p {
  margin: 0 0 8px;
}
small {
  color: #475569;
}
article + article {
  margin-top: 12px;
}
</style>
